import { Select } from '@cian/ui-kit';
import { IOption } from '@cian/ui-kit/types';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOptions } from './utils/getOptions';
import { changeDistrict } from '../../../actions/district';
import { FormField } from '../../../components/FormField';
import { selectDistrict } from '../../../selectors/district';
import { TThunkDispatch } from '../../../types/redux/thunk';

export const District: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const district = useSelector(selectDistrict);
  const districtVariants: IOption[] = React.useMemo(getOptions, []);

  const handleChange = React.useCallback(
    (value: string) => {
      dispatch(changeDistrict(value));
    },
    [dispatch],
  );

  return (
    <FormField label="В каком районе?" data-name="DistrictFormField">
      <Select options={districtVariants} value={district} placeholder="Выберите район" onChange={handleChange} />
    </FormField>
  );
};
